import { message } from 'antd';
import { TFunction } from 'i18next';
import download from '@/utils/download';

export const downloadImage = (url: string, filename: string, translate: TFunction) => {
  try {
    download(url, filename);
  } catch (error) {
    message.error(translate('uploadImageDownloadError', { filename: filename || '' }));
  }
};
